// Eventually, we can delete this file once web is migrated away from Formik.
// eslint-disable-next-line @alto/prefer-react-hook-form
import { type FormikHandlers } from 'formik';
import { type ChangeEventHandler } from 'react';
import { type FieldPath, type FieldValues, type UseControllerReturn } from 'react-hook-form';

// Define Formik types manually to avoid CI type resolution issues with direct imports
// These match the types from formik@2.4.9's FieldInputProps and FieldMetaProps interfaces
type FieldInputProps<Value> = {
  value: Value;
  name: string;
  multiple?: boolean;
  checked?: boolean;
  onChange: FormikHandlers['handleChange'];
  onBlur: FormikHandlers['handleBlur'];
};

type FieldMetaProps<Value> = {
  value: Value;
  error?: string;
  touched: boolean;
  initialValue?: Value;
  initialTouched: boolean;
  initialError?: string;
};

export type Field = {
  error: string;
  invalid: boolean;
  onChange: ChangeEventHandler;
  touched: boolean;
  value: string;
};

export default function mapFieldToInputProps(field: Field) {
  return {
    meta: {
      error: field.error,
      touched: field.touched,
      invalid: field.invalid,
    },
    ...field,
  };
}

export function mapFormikFieldToInputProps(field: FieldInputProps<any>, meta: FieldMetaProps<any>) {
  return {
    meta: { ...meta, invalid: !!meta.error },
    ...field,
  };
}

export function mapControllerToInputProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>(
  controller: UseControllerReturn<TFieldValues, TName>,
) {
  return {
    testID: controller.field.name,
    error: controller.fieldState.error?.message,
    touched: controller.fieldState.isTouched,
    ...controller.field,
  };
}
